import { api } from "../../services/api"
import { adminProductApi, listAllUserApi }  from "../../services/apiVariables" 
import { GetMonthYear, GetCurrentDate } from '@src/function.js'

// ----------------------Product----------------------------
export function adminProduct () {
   return (dispatch) => {  
    dispatch({ type: 'Product_LOADING' }) 
    api(adminProductApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Product_SUCCESS', data }),
           error => dispatch({ type:'Product_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

export function UserAllDetails() {
   return (dispatch) => { 
     dispatch({ type: 'UserAll_LOADING' }) 
    api(listAllUserApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'UserAll_SUCCESS', data }),
           error => dispatch({ type:'UserAll_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}